import Global from '../../../global';
import { eEnvironments } from '../../../utils/enums';

function getKambiEndpoints(useProdApis = false) {
  const env = Global.config.environment;
  const kambiEndpoints = require(`./kambi.${
    useProdApis ? eEnvironments.prod : env
  }.js`).default;

  return kambiEndpoints;
}

export function getOfferingApi(useProdApis = false) {
  const kambiEndpoints = getKambiEndpoints(useProdApis);
  const { server, defaultValue } = kambiEndpoints.offeringAPI;
  const val = !process.env.BROWSER && server ? server : defaultValue;
  return val;
}

export function getPlayerApi(brand, useProdApis = false) {
  const kambiEndpoints = getKambiEndpoints(useProdApis);
  const { brand: brandOptions, defaultValue } = kambiEndpoints.playerAPI;

  return brandOptions && brandOptions.ids.includes(brand)
    ? brandOptions.endpoint
    : defaultValue;
}

export function getPushAPI(useProdApis = false) {
  const kambiEndpoints = getKambiEndpoints(useProdApis);
  return kambiEndpoints.pushAPI;
}

export function getKambiClientSDK(useProdApis = false) {
  const kambiEndpoints = getKambiEndpoints(useProdApis);
  return kambiEndpoints.skdScript;
}

export function getWidgetsAPI(useProdApis = false) {
  const kambiEndpoints = getKambiEndpoints(useProdApis);
  return kambiEndpoints.widgetsAPI;
}
